var SupportCommonBaseInputsView, SupportCommonBaseView,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportCommonBaseView = require('./common_base_view');

SupportCommonBaseInputsView = (function(superClass) {
  extend(SupportCommonBaseInputsView, superClass);

  function SupportCommonBaseInputsView() {
    this.validateEmailForm = bind(this.validateEmailForm, this);
    return SupportCommonBaseInputsView.__super__.constructor.apply(this, arguments);
  }

  SupportCommonBaseInputsView.prototype.initialize = function(options) {
    this.options = options || {};
    return this.inputViews = [];
  };

  SupportCommonBaseInputsView.prototype.renderInputViews = function(objects, componentListElement) {
    var i, len, obj, results, view;
    results = [];
    for (i = 0, len = objects.length; i < len; i++) {
      obj = objects[i];
      view = this.getViewByObjectType(obj);
      if (!view) {
        continue;
      }
      this.inputViews.push(view);
      view.render();
      results.push(this.$el.find(componentListElement).append(view.el));
    }
    return results;
  };

  SupportCommonBaseInputsView.prototype.isInputValid = function() {
    var i, len, ref, view;
    ref = this.inputViews;
    for (i = 0, len = ref.length; i < len; i++) {
      view = ref[i];
      if (!view.isInputValid()) {
        return false;
      }
    }
    return true;
  };

  SupportCommonBaseInputsView.prototype.collectInputFromComponents = function(data) {
    var i, len, ref, view;
    ref = this.inputViews;
    for (i = 0, len = ref.length; i < len; i++) {
      view = ref[i];
      view.populateInput(data);
    }
    return data;
  };

  SupportCommonBaseInputsView.prototype.isRequiredInputGiven = function() {
    var i, len, ref, view;
    ref = this.inputViews;
    for (i = 0, len = ref.length; i < len; i++) {
      view = ref[i];
      if (view.isInputCompulsory && !view.isInputGiven()) {
        return false;
      }
    }
    return true;
  };

  SupportCommonBaseInputsView.prototype.validateEmailForm = function() {
    if (this.isRequiredInputGiven()) {
      return this.enableSubmit();
    } else {
      return this.disableSubmit();
    }
  };

  SupportCommonBaseInputsView.prototype.onSubmitClick = function() {
    var data;
    this.disableSubmit();
    if (this.isInputValid()) {
      data = this.getFormData();
      return this.submitForm(data);
    } else {
      return this.validateEmailForm();
    }
  };

  SupportCommonBaseInputsView.prototype.getFormData = function() {
    var data;
    data = this.model.getBasicTicketData();
    this.collectInputFromComponents(data);
    return data;
  };

  SupportCommonBaseInputsView.prototype.enableSubmit = function() {
    $('.submit-button', this.$el).removeClass('disabled');
    return $('.submit-button', this.$el).attr('disabled', false);
  };

  SupportCommonBaseInputsView.prototype.disableSubmit = function() {
    $('.submit-button', this.$el).addClass('disabled');
    return $('.submit-button', this.$el).attr('disabled', true);
  };

  SupportCommonBaseInputsView.prototype.focusFormInput = function(event) {
    this.target = $(event.target).parent();
    if (!$(event.target).val()) {
      this.target.addClass('focused');
      if ($(event.target).hasClass('phone_number_input')) {
        return $(".phone_number_input").inputmask();
      }
    } else {
      return this.target.addClass('filled focused');
    }
  };

  SupportCommonBaseInputsView.prototype.focusoutFormInput = function(event) {
    this.target = $(event.target);
    this.targetParent = $(event.target).parent();
    this.targetParent.removeClass('focused');
    if (!this.target.val()) {
      this.targetParent.removeClass('filled');
    } else {
      this.targetParent.addClass('filled');
    }
    return this.validateOnFocusOut(this.target, this.inputViews);
  };

  SupportCommonBaseInputsView.prototype.getViewByObjectType = function() {};

  SupportCommonBaseInputsView.prototype.validateOnFocusOut = function(DomElement) {};

  return SupportCommonBaseInputsView;

})(SupportCommonBaseView);

module.exports = SupportCommonBaseInputsView;

//# sourceMappingURL=data:application/json;base64,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
